var SupportCommonBaseInputsView, SupportCommonBaseView,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportCommonBaseView = require('./common_base_view');

SupportCommonBaseInputsView = (function(superClass) {
  extend(SupportCommonBaseInputsView, superClass);

  function SupportCommonBaseInputsView() {
    this.validateEmailForm = bind(this.validateEmailForm, this);
    return SupportCommonBaseInputsView.__super__.constructor.apply(this, arguments);
  }

  SupportCommonBaseInputsView.prototype.initialize = function(options) {
    this.options = options || {};
    return this.inputViews = [];
  };

  SupportCommonBaseInputsView.prototype.renderInputViews = function(objects, componentListElement) {
    var i, len, obj, results, view;
    results = [];
    for (i = 0, len = objects.length; i < len; i++) {
      obj = objects[i];
      view = this.getViewByObjectType(obj);
      if (!view) {
        continue;
      }
      this.inputViews.push(view);
      view.render();
      results.push(this.$el.find(componentListElement).append(view.el));
    }
    return results;
  };

  SupportCommonBaseInputsView.prototype.isInputValid = function() {
    var i, len, ref, view;
    ref = this.inputViews;
    for (i = 0, len = ref.length; i < len; i++) {
      view = ref[i];
      if (!view.isInputValid()) {
        return false;
      }
    }
    return true;
  };

  SupportCommonBaseInputsView.prototype.collectInputFromComponents = function(data) {
    var i, len, ref, view;
    ref = this.inputViews;
    for (i = 0, len = ref.length; i < len; i++) {
      view = ref[i];
      view.populateInput(data);
    }
    return data;
  };

  SupportCommonBaseInputsView.prototype.isRequiredInputGiven = function() {
    var i, len, ref, view;
    ref = this.inputViews;
    for (i = 0, len = ref.length; i < len; i++) {
      view = ref[i];
      if (view.isInputCompulsory && !view.isInputGiven()) {
        return false;
      }
    }
    return true;
  };

  SupportCommonBaseInputsView.prototype.validateEmailForm = function() {
    if (this.isRequiredInputGiven()) {
      return this.enableSubmit();
    } else {
      return this.disableSubmit();
    }
  };

  SupportCommonBaseInputsView.prototype.onSubmitClick = function() {
    var data;
    this.disableSubmit();
    if (this.isInputValid()) {
      data = this.getFormData();
      return this.submitForm(data);
    } else {
      return this.validateEmailForm();
    }
  };

  SupportCommonBaseInputsView.prototype.getFormData = function() {
    var data;
    data = this.model.getBasicTicketData();
    this.collectInputFromComponents(data);
    return data;
  };

  SupportCommonBaseInputsView.prototype.enableSubmit = function() {
    $('.submit-button', this.$el).removeClass('disabled');
    return $('.submit-button', this.$el).attr('disabled', false);
  };

  SupportCommonBaseInputsView.prototype.disableSubmit = function() {
    $('.submit-button', this.$el).addClass('disabled');
    return $('.submit-button', this.$el).attr('disabled', true);
  };

  SupportCommonBaseInputsView.prototype.focusFormInput = function(event) {
    this.target = $(event.target).parent();
    if (!$(event.target).val()) {
      this.target.addClass('focused');
      if ($(event.target).hasClass('phone_number_input')) {
        return $(".phone_number_input").inputmask();
      }
    } else {
      return this.target.addClass('filled focused');
    }
  };

  SupportCommonBaseInputsView.prototype.focusoutFormInput = function(event) {
    this.target = $(event.target);
    this.targetParent = $(event.target).parent();
    this.targetParent.removeClass('focused');
    if (!this.target.val()) {
      this.targetParent.removeClass('filled');
    } else {
      this.targetParent.addClass('filled');
    }
    return this.validateOnFocusOut(this.target, this.inputViews);
  };

  SupportCommonBaseInputsView.prototype.getViewByObjectType = function() {};

  SupportCommonBaseInputsView.prototype.validateOnFocusOut = function(DomElement) {};

  return SupportCommonBaseInputsView;

})(SupportCommonBaseView);

module.exports = SupportCommonBaseInputsView;

//# sourceMappingURL=data:application/json;base64,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
